import React from 'react'
import { RadLink } from './RadLink'

export function RadExternalLink ({ href, children, ...rest }) {
  return (
    <RadLink
      external
      externalIconAriaLabel='Opens in a new tab'
      href={href}
      target='_blank'
      {...rest}
    >
      {children == null ? href.split('/').pop() : children}
    </RadLink>
  )
}
